import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Color, MeshBasicMaterial } from "three";
import {
  windTurbineScale,
  getRangeModeDisplayColor,
  filterObjectsByColorbarRange,
} from "../utils";

import axios from "axios";
import {
  setTurbineInfoBoxShow,
  setWindTurbineIsLoading,
  setWindTurbineValuesRanges,
  updateTurbineData,
} from "../../redux/windTurbine";
import { useColorBar } from "../CustomHooks";
import { getOldProjectId } from "../utility/hardconding";
import { SphereInstancedMesh } from "./InstancedMesh";
import { reduxLocalStorage } from "../utility/storage";

function generateMinMax(valueList) {
  const minVal = Math.min(...valueList);
  const maxVal = Math.max(...valueList);
  return { minVal, maxVal };
}

function getValuesRanges(data) {
  if (!data.length) return;

  const keys = [
    "monthly_generation",
    "aep_kwh_frequency",
    "avg_wind_frequency",
    "avg_wind_frequency_velocity",
  ];
  const result = {};

  data?.forEach((item) => {
    for (const key of keys) {
      if (!result[key]) {
        result[key] = { min: Infinity, max: -Infinity };
      }
      const values =
        key === "avg_wind_frequency_velocity"
          ? Object.keys(item["avg_wind_frequency"])
          : Object.values(item[key]);
      const min = Math.min(...values);
      const max = Math.max(...values);
      result[key].min = Math.min(result[key].min, min);
      result[key].max = Math.max(result[key].max, max);
    }
  });

  const finalResult = {};
  for (const key in result) {
    finalResult[key] = [result[key].min, result[key].max];
  }

  return finalResult;
}

const Zone = (props) => {
  var dispatch = useDispatch();
  var rangeList = generateMinMax(props.data?.map((row) => row.aep_kwh));

  useEffect(() => {
    var valuesRanges = getValuesRanges(props.data);
    valuesRanges.aep_kwh = [rangeList.minVal, rangeList.maxVal];
    dispatch(setWindTurbineValuesRanges(valuesRanges));
  }, [props.data]);

  const { max, min, rangeMode } = useColorBar(
    "Wind Turbine",
    "Zone",
    rangeList.minVal,
    rangeList.maxVal,
  );
  var windTurbineSelector = useSelector(
    (state) => state.windTurbine.value.checkStatus,
  );
  const visible = !!windTurbineSelector?.[props.id];

  const { infoBoxShow, TurbineData: selectedSensorData } = useSelector(
    (state) => state.windTurbine,
  );

  const displaySensors = filterObjectsByColorbarRange(
    props.data,
    (sensor) => sensor?.aep_kwh,
    min,
    max,
    rangeMode,
  );

  const onClick = (config) => {
    const sensor = displaySensors[config.instanceId];
    dispatch(updateTurbineData(sensor));
    dispatch(setTurbineInfoBoxShow(true));
    config.stopPropagation();
  };

  const setColor = (sensor) => {
    const { color } = getRangeModeDisplayColor(sensor?.aep_kwh, {
      min,
      max,
      rangeMode,
      colorScale: windTurbineScale,
    });
    return new Color(color);
  };

  const getObjectPosition = (sensor) => {
    return sensor?.position;
  };
  return (
    <SphereInstancedMesh
      objects={displaySensors}
      setColor={setColor}
      groupProps={{
        onClick,
        visible,
      }}
      getObjectPosition={getObjectPosition}
      radius={0.4}
      updateDependencyArray={[min, max, rangeMode]}
      highlightProps={{
        highlightedObject: [selectedSensorData],
        showHighlight: infoBoxShow,
        radius: 0.9,
        getObjectPosition,
      }}
    />
  );
};

const WindTurbine = () => {
  const project_id = reduxLocalStorage.getItem("project_id");
  const oldProjectId = getOldProjectId(project_id);
  const [resultArray, setResultArray] = useState([]);
  const [nodes, setNodes] = useState(false);
  const dispatch = useDispatch();
  var windTurbineSelector = useSelector(
    (state) => state.windTurbine.value.checkStatus,
  );
  const visible = Object.values(windTurbineSelector)?.some((e) => e);

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setWindTurbineIsLoading(true));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/turbin_data/?project_id=${project_id}`,
        );
        if (response.status === 200) {
          setNodes(true);
          setResultArray(response.data);
        }
      } finally {
        dispatch(setWindTurbineIsLoading(false));
      }
    };

    if (visible && !nodes) fetchData();
  }, [visible]);

  if (oldProjectId == "86" && resultArray?.length)
    return <Zone id={0} data={resultArray} />;
};

export default WindTurbine;
